var _rect, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_772_26484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 8H8V48H48V8Z",
    fill: "#2E3035"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_772_26484)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 28L28 8L8 28L28 48L48 28ZM19.6094 31.2325H17.0885V29.5137H19.3659C19.3373 29.1271 19.3229 28.726 19.3229 28.3249C19.3229 27.8953 19.3373 27.4799 19.3802 27.0789H17.0885V25.3601H19.6237C20.6263 20.7911 23.9921 17.9695 28.5612 17.9695C32.9297 17.9695 36.1093 20.6336 36.7396 24.2H34.1615C33.5169 22.0229 31.3972 20.3614 28.5612 20.3614C25.5533 20.3614 23.2331 22.2521 22.3308 25.3601H30.638V27.0789H22.0013C21.9727 27.4799 21.944 27.8953 21.944 28.3249C21.944 28.7404 21.9584 29.1271 22.0013 29.5137H30.638V31.2325H22.3164C23.1757 34.3979 25.5104 36.3028 28.5755 36.3028C31.4975 36.3028 33.4311 34.9421 34.1615 32.9513H36.7396C35.8229 36.4747 33.0013 38.6948 28.5612 38.6948C23.9349 38.6948 20.5833 35.8732 19.6094 31.2325Z",
    fill: "#DD9323"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_772_26484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 42,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0936 24.8832C15.3329 24.8435 12.0459 25.6252 7.82086 28.1507C7.46369 27.7051 8.91522 26.4569 8.66691 26.0003C8.66832 25.3357 11.3328 23.6941 11.3336 23.3336C18.0002 18.667 25.3336 8.66667 28.0002 8C31.9872 11.4384 39.0285 18.8768 46.6669 24.0007C46.6778 24.2589 46.6626 24.2772 46.6669 24.668C46.6656 25.3348 47.3354 25.8061 47.3336 26.6673C46.3361 25.5712 48.9028 27.5509 48.8966 27.6612C44.4096 29.9856 40.6341 30.7225 37.2298 30.512C33.4344 30.2771 30.2625 28.8609 27.3929 27.5797C27.2834 27.5309 27.1745 27.4823 27.066 27.4339C24.0393 26.0847 21.314 24.9295 18.0936 24.8832Z",
    fill: "#2E3035"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_772_26484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 28L28 8L8 28L28 48L48 28ZM19.6099 31.2325H17.0891V29.5137H19.3664C19.3378 29.1271 19.3234 28.726 19.3234 28.3249C19.3234 27.8953 19.3378 27.4799 19.3807 27.0789H17.0891V25.3601H19.6242C20.6268 20.7911 23.9927 17.9695 28.5617 17.9695C32.9303 17.9695 36.1099 20.6336 36.7401 24.2H34.162C33.5175 22.0229 31.3976 20.3614 28.5617 20.3614C25.5539 20.3614 23.2336 22.2521 22.3312 25.3601H30.6385V27.0789H22.0019C21.9732 27.4799 21.9445 27.8953 21.9445 28.3249C21.9445 28.7404 21.9588 29.1271 22.0019 29.5137H30.6385V31.2325H22.3169C23.1763 34.3979 25.5109 36.3028 28.576 36.3028C31.4979 36.3028 33.4315 34.9421 34.162 32.9513H36.7401C35.8235 36.4747 33.0019 38.6948 28.5617 38.6948C23.9355 38.6948 20.5839 35.8732 19.6099 31.2325Z",
    fill: "#F8D12E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurn);
export default __webpack_public_path__ + "static/media/eurn.c101d776dd308f2a000c7ca1cf54b8ad.svg";
export { ForwardRef as ReactComponent };